deleteRegister = function (id) {
    if (confirm("Deseja excluir esse registro?")) {
        document.getElementById(id).submit();
    }
    return false;
};

$('body').on('click', 'a.delete', function (event) {
    event.preventDefault();
    if (confirm("Deseja excluir esse registro?")) {
        let link = $(this);
        let url = link.attr('href').replace(':8000', ':3000');
        let formToken = $('meta[name="csrf-token"]').attr('content');

        $.ajax({
            method: "DELETE",
            url: url,
            data: {"_token": formToken}
        }).done(function (msg) {
            alert(msg);
            window.location.reload();
        }).fail(function (msg) {
            alert(msg);
        });
    }
});


// WEBPACK FOOTER //
// ./resources/assets/admin/js/scripts/script-delete-register.js